import React from 'react'
import SecureMessageAttachment from '../../components/media/SecureMessageAttachment'

export default function Attachment({ message, onOpenImage, onOpen }) {
    return (
        <SecureMessageAttachment
            message={message}
            onOpen={onOpen || onOpenImage}
        />
    )
}
